<div class="d-md-flex">
  <div class="col-5 page-left-side d-none d-md-block">
    <img
      [src]="tenantConfigService.tenant.sidePageImageUrl"
      alt="Login Image"
    />
  </div>
  <div class="col-12 col-md-7 page-right-side">
    <div class="row pt-5 mb-5 pb-5">
      <div
        class="col-10 mx-auto d-flex align-items-center justify-content-between"
      >
        <div class="logo">
          <a [routerLink]="['/']">
            <img
              [src]="tenantConfigService.tenant.coloredLogoUrl"
              [alt]="
                (tenantConfigService.tenant.companyName || 'Company') + ' Logo'
              "
              class="auth-logo"
            />
          </a>
        </div>
        <div class="language-container">
          <select
            class="language-select"
            (change)="onLanguageChange($event)"
            [value]="languageService.currentLanguage"
          >
            <option value="en">English</option>
            <option value="ar">العربية</option>
          </select>
        </div>
      </div>
    </div>

    <div class="col-12 p-4 form-content">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </div>
</div>
